<h1>{{ event_name }}</h1>
<div class="beer-table-container">
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let beer" class="status-cell">
        <mat-icon
          [class]="'status-icon status-' + (beer.status || 'default')"
          (click)="cycleStatus(beer)"
          (keydown.enter)="cycleStatus(beer)"
          tabindex="0"
          role="button"
          title="Click to change status">{{ getStatusIcon(beer.status) }}</mat-icon>
      </td>
    </ng-container>

    <!-- Brewery Column -->
    <ng-container matColumnDef="brewery">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Brewery</th>
      <td mat-cell *matCellDef="let beer">{{ beer.brewery }}</td>
    </ng-container>

    <!-- Beer Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Beer Name</th>
      <td mat-cell *matCellDef="let beer">
        @if (beer.description) {
          <span
            class="beer-name beer-name-link"
            (click)="openBeerDetails(beer)"
            (keydown.enter)="openBeerDetails(beer)"
            tabindex="0"
            role="button">
            {{ beer.name }}
          </span>
        } @else {
          {{ beer.name }}
        }
      </td>
    </ng-container>

    <!-- ABV Column -->
    <ng-container matColumnDef="abv">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ABV</th>
      <td mat-cell *matCellDef="let beer">{{ beer.abv }}%</td>
    </ng-container>

    <!-- Style Column -->
    <ng-container matColumnDef="style">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Style</th>
      <td mat-cell *matCellDef="let beer">{{ beer.style }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<p class="event-link">
  <a [href]="event_url" target="_blank" rel="noopener noreferrer">
    {{ event_name }} website
  </a>
</p>
<p class="data-source">
  <a [href]="data_source_url" target="_blank" rel="noopener noreferrer">
    Beer data source
  </a>
</p>
<p class="clear-status">
  <a href="#" (click)="clearBeerStatuses(); $event.preventDefault()">
    Clear saved beer statuses
  </a>
</p>
